import { Colors } from '@ab-core/colors';
import { SPACING } from '@ab-core/spacing';
import { Z_INDEX } from '@ab-core/z-index';
import styled from 'styled-components';

export const BarContainer = styled.div`
    position: fixed;
    z-index: ${Z_INDEX.MODAL};
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
`;

export const PanelWrapper = styled.div`
    display: grid;
    grid-template-rows: 0fr;
    background: ${Colors.white};
    transition: grid-template-rows 250ms ease-in-out;

    &.ab-crosselling-bar-is-open {
        grid-template-rows: 1fr;
    }
`;

export const PanelInner = styled.div`
    overflow: hidden;
    min-height: 0;
`;

export const PanelContent = styled.div`
    border-top: 1px solid ${Colors.gray30};
    padding: ${SPACING.SMALL_3} ${SPACING.MEDIUM};
`;

export const RedDot = styled.span`
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-left: 4px;
    border-radius: 50%;
    background: ${Colors.primary};
    vertical-align: middle;
`;
